<template>
    <div class="status-bar">
        <div
            :style="{width: `${percent}%`}"
            class="status-bar__status-line"
        >
        </div>
    </div>
</template>

<script>
export default {
    name: 'StatusBar',
    /**
     * Входные данные компонента
     * @property {number} percent - процент 
     */
    props: {
        percent: {
            type: Number,
            default: 0
        }
    }
}
</script>

<style lang="scss" scoped>
    .status-bar {
        width: 100%;
        background-color: #DCDCDC;
        border-radius: 50px;
    }
    .status-bar__status-line {
        border-radius: 50px;
        height: 20px;
        background-color: #3CB371;
    }
</style>